import { prop, join, without, values } from 'ramda';
import { createSelector } from 'reselect';
import { getHighwaySectionsAllowedCountries, getReferentialHighwayCountries } from './global';

export const getLocation = prop('location');
export const getPosition = createSelector(getLocation, location => location?.position ?? location);
export const getHighway = createSelector(getLocation, location => location?.highway);
export const getCoveredGarage = createSelector(getLocation, location => location?.coveredGarage);
export const getAddress = createSelector(getLocation, prop('address'));
export const getCountry = createSelector(getAddress, prop('country'));
const getHighwayLocation = createSelector(getLocation, prop('highwayLocation'));
export const getHighwayMetres = createSelector(getHighwayLocation, highwayLocation => highwayLocation?.milestone);

export const getIsCountryHighwaySectionAllowed = createSelector(
  getCountry,
  getHighwaySectionsAllowedCountries,
  (country, supportedCountries) => supportedCountries.includes(country)
);

export const getIsCountryReferentialHighwayPOIAllowed = createSelector(
  getCountry,
  getReferentialHighwayCountries,
  (country, supportedCountries) => supportedCountries.includes(country)
);

export const getFormatedAddress = createSelector(getAddress, address => join(' ', without([undefined], values(address))));

export const getHighwayCode = createSelector(getHighwayLocation, prop('highway'));

export const getHighwayDirection = createSelector(getHighwayLocation, prop('direction'));
